/** Resolve catalog images from MySQL-backed product rows only (no static fallbacks). */

import { productGalleryImagePaths } from '../productMediaUtils';

function imageFromProduct(p) {
  const paths = productGalleryImagePaths(p);
  return paths[0] || '';
}

function productMatchesGroup(p, groupKey) {
  const g = String(groupKey || '').trim().toLowerCase();
  if (!g) return false;
  const typ = String(p?.type || '').trim().toLowerCase();
  const sub = String(p?.subcategory || '').trim().toLowerCase();
  return typ === g || sub === g;
}

export function firstProductImage(productList) {
  const list = productList || [];
  const hit = list.find((p) => imageFromProduct(p));
  return hit ? imageFromProduct(hit) : '';
}

export function thumbForGroup(productList, groupKey) {
  const list = productList || [];
  if (groupKey) {
    const inGroup = list.find((p) => productMatchesGroup(p, groupKey) && imageFromProduct(p));
    if (inGroup) return imageFromProduct(inGroup);
  }
  return firstProductImage(list);
}
